const TEAMS_APP_ID = process.env.REACT_APP_TEAMS_ID;

export { TEAMS_APP_ID };
